var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/FolderChecklist.tsx";
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FolderChecklist = ({
  color
}) => /*#__PURE__*/_jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsx("rect", {
    width: "24",
    height: "24",
    rx: "4",
    fill: color
  }), /*#__PURE__*/_jsx("path", {
    d: "M18 7.5H12L10.9425 6.4425C10.6575 6.1575 10.275 6 9.8775 6H6C5.175 6 4.5075 6.675 4.5075 7.5L4.5 16.5C4.5 17.325 5.175 18 6 18H18C18.825 18 19.5 17.325 19.5 16.5V9C19.5 8.175 18.825 7.5 18 7.5ZM8.34 14.4675L7.2825 13.41C6.99 13.1175 6.99 12.645 7.2825 12.3525C7.575 12.06 8.0475 12.06 8.34 12.3525L8.8725 12.885L10.995 10.7625C11.2875 10.47 11.76 10.47 12.0525 10.7625C12.345 11.055 12.345 11.5275 12.0525 11.82L9.3975 14.475C9.105 14.76 8.6325 14.76 8.34 14.4675ZM16.0575 12.75L16.7175 13.41C17.01 13.7025 17.01 14.175 16.7175 14.4675C16.425 14.76 15.9525 14.76 15.66 14.4675L15 13.8075L14.34 14.4675C14.0475 14.76 13.575 14.76 13.2825 14.4675C12.99 14.175 12.99 13.7025 13.2825 13.41L13.9425 12.75L13.2825 12.09C12.99 11.7975 12.99 11.325 13.2825 11.0325C13.575 10.74 14.0475 10.74 14.34 11.0325L15 11.6925L15.66 11.0325C15.9525 10.74 16.425 10.74 16.7175 11.0325C17.01 11.325 17.01 11.7975 16.7175 12.09L16.0575 12.75Z",
    fill: "white"
  })]
});